(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('googleMap', function($window, $timeout, searchUnitService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            key: '@',
            model: '='
        },
        template: '<div></div>',
        link(scope, el) {
            const headerHeight = 95;
            const throttle = 100;
            const pos = searchUnitService.getSearchArea();
            let map;
            let initialised = false;
            let centre;
            let promise = null;

            scope.$on('mapTabSelected', function() {
                if (!$window.google || !$window.google.maps) {
                    $(`<script type="text/javascript" id="googleScript" src="https://maps.googleapis.com/maps/api/js?client=${TRPCONFIG.Domain.GoogleClientId}&sensor=false&callback=googleMapLoadedCallback" />`)
                    .appendTo($('head'));
                } else {
                    $timeout($window.googleMapLoadedCallback, 50);
                }
            });

            scope.$on('$destroy', function() {
                delete $window.googleMapLoadedCallback;
                $($window).off('resize', windowResize);
            });

            function windowResize() {
                if (promise !== null) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(resizeMap, throttle);
            }

            $window.googleMapLoadedCallback = function() {
                if (!initialised && !map) {
                    resizeMap();

                    centre = new google.maps.LatLng(scope.model.Latitude, scope.model.Longitude);
                    map = new google.maps.Map(el[0], {
                        zoom: 18,
                        scrollwheel: false,
                        overviewMapControl: false,
                        center: centre,
                        mapTypeControl: false,
                        streetViewControl: true,
                        scaleControl: true
                    });

                    const hotelMarker = new google.maps.Marker({
                        position: centre,
                        map,
                        icon: 'build/img/Maps/map-pin.svg',
                        animation: google.maps.Animation.DROP
                    });

                    const hotelInfoWindow = new google.maps.InfoWindow({
                        content: `<div class="no-scrollbars">${scope.model.Title}</div>`
                    });

                    hotelInfoWindow.open(map, hotelMarker);

                    google.maps.event.addListener(hotelMarker, 'click', function() {
                        hotelInfoWindow.open(map, hotelMarker);
                    });


                    if (pos) {
                        const bounds = new google.maps.LatLngBounds();
                        bounds.extend(centre);

                        const me = new google.maps.LatLng(pos.Latitude, pos.Longitude);

                        new google.maps.Marker({
                            position: me,
                            map,
                            icon: 'build/img/Maps/marker-icon.png',
                            animation: google.maps.Animation.DROP
                        });

                        bounds.extend(me);
                        map.fitBounds(bounds);
                    }


                    $($window).on('resize', windowResize);

                    initialised = true;
                }

                resizeMap();
            };

            function resizeMap() {
                el.width('100%');
                el.height($($window).height() - headerHeight);
                if (map) {
                    google.maps.event.trigger(map, 'resize');
                }
            }
        }
    };
});
})();
